package org.example.project.enginemodule

import androidx.compose.runtime.Composable
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun ShopActionStage(
    module: ShopModuleMeta,
    state: ModuleState,
    progress: Int,
    onClose: () -> Unit
) {
    val isUninstall = state == ModuleStateVal.UNINSTALLING
    val title = if (isUninstall) "Modul wird deinstalliert" else "Modul wird installiert"
    val messageText = if (isUninstall) {
        "Die bestehende Installation von ${module.title} wird gerade entfernt."
    } else {
        "Die Installation von ${module.title} wird vorbereitet. Das Modul wird danach direkt in deinen Inhalten aktualisiert."
    }
    val progressColor = if (isUninstall) Color("#EF5350") else Color("#5b9bff")
    val progressLabelColor = if (isUninstall) Color("#ff8da1") else Color("#8fd2ff")

    Div({
        style {
            position(Position.Fixed)
            property("inset", "0")
            backgroundColor(Color("rgba(6,8,12,0.72)"))
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            property("z-index", "120000")
            padding(28.px)
            boxSizing("border-box")
        }
    }) {
        Div({
            style {
                width(920.px)
                maxWidth(100.percent)
                borderRadius(28.px)
                overflow("hidden")
                property("border", "1px solid rgba(255,255,255,0.12)")
                property("box-shadow", "0 34px 90px rgba(0,0,0,0.34)")
                backgroundColor(Color("rgba(12,15,20,0.98)"))
                display(DisplayStyle.Grid)
                property("grid-template-columns", "minmax(320px, 1.15fr) minmax(360px, 0.85fr)")
            }
        }) {
            Div({
                style {
                    minHeight(420.px)
                    property(
                        "background",
                        if (module.iconPath.isNotBlank()) {
                            "linear-gradient(115deg, rgba(91,155,255,0.20) 0%, rgba(15,19,26,0.88) 62%), url('${module.iconPath}') center/cover no-repeat"
                        } else {
                            "linear-gradient(135deg, rgba(91,155,255,0.24) 0%, rgba(17,20,26,0.94) 100%)"
                        }
                    )
                    position(Position.Relative)
                }
            }) {
                Div({
                    style {
                        position(Position.Absolute)
                        left(24.px)
                        bottom(24.px)
                        right(24.px)
                        display(DisplayStyle.Flex)
                        justifyContent(JustifyContent.SpaceBetween)
                        alignItems(AlignItems.Center)
                        gap(16.px)
                    }
                }) {
                    Span({ style { color(Color("#eef2f9")); fontSize(12.px); property("text-shadow", "0 2px 8px rgba(0,0,0,0.55)") } }) {
                        Text("Version ${module.version}")
                    }
                    Span({ style { color(Color("#eef2f9")); fontSize(12.px); property("text-shadow", "0 2px 8px rgba(0,0,0,0.55)") } }) {
                        Text("Screens: ${module.enabledScreens.size}")
                    }
                }
            }

            Div({
                style {
                    minHeight(420.px)
                    padding(34.px, 34.px, 28.px, 34.px)
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    justifyContent(JustifyContent.SpaceBetween)
                    gap(22.px)
                    boxSizing("border-box")
                }
            }) {
                Div({
                    style {
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Column)
                        gap(14.px)
                    }
                }) {
                    Span({
                        style {
                            color(progressLabelColor)
                            fontSize(12.px)
                            fontWeight("700")
                            property("letter-spacing", "0.06em")
                            property("text-transform", "uppercase")
                        }
                    }) { Text(if (isUninstall) "Deinstallation" else "Installation") }

                    P({
                        style {
                            margin(0.px)
                            color(Color("#f5f6f8"))
                            fontSize(30.px)
                            fontWeight("700")
                            lineHeight("1.12")
                        }
                    }) { Text(title) }

                    P({
                        style {
                            margin(0.px)
                            color(Color("#aeb7c6"))
                            fontSize(15.px)
                            lineHeight("1.7")
                        }
                    }) { Text(messageText) }
                }

                Div({
                    style {
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Column)
                        gap(14.px)
                    }
                }) {
                    Div({
                        style {
                            height(14.px)
                            borderRadius(999.px)
                            backgroundColor(Color("rgba(255,255,255,0.05)"))
                            property("border", "1px solid rgba(255,255,255,0.10)")
                            overflow("hidden")
                        }
                    }) {
                        Div({
                            style {
                                height(100.percent)
                                width(progress.percent)
                                backgroundColor(progressColor)
                                property("transition", "width 0.12s linear")
                            }
                        })
                    }

                    Div({
                        style {
                            display(DisplayStyle.Flex)
                            justifyContent(JustifyContent.SpaceBetween)
                            alignItems(AlignItems.Center)
                            gap(16.px)
                        }
                    }) {
                        Span({ style { color(progressLabelColor); fontSize(13.px); fontWeight("600") } }) {
                            Text(if (isUninstall) "Deinstalliere Modul... $progress%" else "Installiere Modul... $progress%")
                        }
                        Span({ style { color(Color("#7f8ba0")); fontSize(12.px) } }) {
                            Text(module.title)
                        }
                    }
                }

                Div({
                    style {
                        display(DisplayStyle.Flex)
                        justifyContent(JustifyContent.FlexEnd)
                    }
                }) {
                    LumaticaButton(
                        label = "Im Hintergrund weiter",
                        onClick = { onClose() },
                        variant = LumaticaButtonVariant.Standard,
                        heightPx = 40
                    )
                }
            }
        }
    }
}
